<template>
  <div>
    <el-row
      class="tw-px-2"
      :gutter="20"
      v-if="
        [roles.teamAdmin, roles.clubAdmin, roles.programAdmin, roles.clubProgramAdmin].includes(
          clearance
        )
      "
    >
      <button
        class="tw-justify-center tw-w-full tw-mt-6 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-5 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64"
        type="success"
        @click="addList"
      >
        Add List
      </button>
    </el-row>

    <el-row :gutter="10" class="mb-2">
      <el-col>
        <data-tables
          :data="trainings"
          :table-props="{ border: false }"
          layout="table"
          class="data-table"
          @row-click="handleRowClick"
        >
          <el-table-column
            :formatter="dateFormatter"
            prop="dateTime"
            label="Training Date"
            width="auto"
          >
          </el-table-column>
          <el-table-column label="Member Count" width="120">
            <template slot-scope="scope">
              {{ getNumCount(scope.row.members.concat(scope.row.manualMembers)) }}
            </template>
          </el-table-column>
        </data-tables>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import _ from "lodash";
import { roles } from "../../utils/constants";

export default {
  name: "TrainingLists",
  data() {
    return {
      roles,
      trainings: [],
      pageNumbers: 1,
      pages: 0,
      trainingsTable: [],
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);
    this.$http
      .get("nrl/api/v1/admin/training-attendances/")
      .then((res) => {
        this.trainings = _.orderBy(res.data.data, ["dateTime"], ["desc"]);

        this.pages = Math.ceil(this.trainings.length / 8);
        this.trainingsTable = this.trainings.slice(0, 8);

        this.$store.commit("root/loading", false);
      })
      .catch(() => {
        this.$customError();
        this.$store.commit("root/loading", false);
      });
  },
  methods: {
    addList() {
      this.$router.push({
        name: "training-participants.add",
      });
    },
    loadMoreData() {
      if (this.pageNumber > this.pages) return;
      this.pageNumber++;
      let records = this.pageNumber * 8;
      this.trainingsTable = this.trainings.slice(0, records);
    },
    handleRowClick(row) {
      this.$router.push({
        name: "training-participants.edit",
        params: {
          id: row._id,
        },
      });
    },
    dateFormatter(row) {
      return row.dateTime ? this.dayjs(row.dateTime).format("MMMM Do YYYY, h:mm:ss a") : "NA";
    },
    getNumCount(members) {
      return members.length;
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss">
h3 {
  text-align: center;
}
.el-col .el-col-24 {
  margin: 5px 0px;
}

.add-training {
  display: flex;
  justify-content: flex-end;
}
</style>
